import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'

class RoadViewActionSheet extends React.Component {
    state = {
    };

    render() {
        return (
            <div>
                {
                    this.props.open ?
                        <ActionSheet className="road-view-action-sheet" isOpen={this.props.open} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true}>
                            <div className="action-sheet-title action-sheet-title--material">이하 정보는 네이버 로드뷰입니다.</div>
                            <iframe title="road-view-action-sheet" src={this.props.frameUrl}/>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>로드뷰 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }
            </div>
        )
    }
}

export default RoadViewActionSheet

